var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Flex from "../../../components/templates/flex";
import { Text } from "../../../components/typography";
import { Icon } from "../../../components/icon";
var borderProps = {
    border: { side: "top", color: "disabled" },
    padding: [6, 0, 0],
};
var Section = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.topBorder, topBorder = _b === void 0 ? true : _b, rest = __rest(_a, ["title", "children", "topBorder"]);
    return (React.createElement(Flex, __assign({ column: true }, (topBorder && borderProps), rest),
        React.createElement(Flex, { margin: [0, 0, 2], gap: 2 },
            React.createElement(Icon, { name: "insights", color: "text", width: "18px", height: "18px" }),
            React.createElement(Text, { strong: true }, title)),
        typeof children === "string" ? React.createElement(Text, null, children) : children));
};
export var Container = function (props) { return (React.createElement(Flex, __assign({ overflow: { vertical: "auto" }, padding: [6, 4], gap: 6, column: true }, props))); };
export default Section;
